import { render, staticRenderFns } from "./multiplayer-page.vue?vue&type=template&id=c5bb3d82&"
import script from "./multiplayer-page.vue?vue&type=script&lang=js&"
export * from "./multiplayer-page.vue?vue&type=script&lang=js&"
import style0 from "./multiplayer-page.vue?vue&type=style&index=0&id=c5bb3d82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports